export var BucketFileFormat;
(function (BucketFileFormat) {
    BucketFileFormat["BUCKET_FILE_FORMAT_AVRO"] = "AVRO";
    BucketFileFormat["BUCKET_FILE_FORMAT_PARQUET"] = "PARQUET";
    BucketFileFormat["BUCKET_FILE_FORMAT_JSON"] = "JSON";
    BucketFileFormat["BUCKET_FILE_FORMAT_CSV"] = "CSV";
    BucketFileFormat["BUCKET_FILE_FORMAT_UNKNOWN"] = "UNKNOWN";
})(BucketFileFormat || (BucketFileFormat = {}));
